module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-toolbar p-component mb-4"
  }, [_c('MonthlyTargetDialog', {
    ref: "targetDialog",
    on: {
      "refresh-list": _vm.loadTargets
    }
  })], 1), _vm._v(" "), _c('MonthlySaleTargetList', {
    ref: "targetList",
    on: {
      "refresh-list": _vm.loadTargets,
      "edit-target": _vm.handleEdit,
      "delete-target": _vm.handleDelete
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d3364fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/account/monthlySalesTarget.vue
// module id = 2295
// module chunks = 0